import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getRelatedPracticeCase } from '../../../utils/api/services/contest';
import Preloader from '../../../components/Preloader/Preloader';
import AttachedContent from '../../../components/AttachedContent/AttachedContent';
import PracticeCard from '../PracticeCard';

export default class PracticeDetailRelatedCases extends Component {
  static propTypes = {
    practice: PropTypes.object.isRequired,
  };

  componentWillMount = () => {
    this.getRelatedPractices();
  };

  getRelatedPractices = () => {
    this.setState({ isLoading: true });
    getRelatedPracticeCase(this.props.practice.id)
      .then((relatedPractices) => {
        this.setState({
          relatedPractices,
        });
      })
      .catch(e => console.log(e))
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const { relatedPractices } = this.state;
    return relatedPractices && relatedPractices.length ? (
      <div className="section">
        <div className="section-title">Похожие случаи из практики</div>

        <div
          className={classNames('card', {
            '-col3': relatedPractices && relatedPractices.length > 2,
          })}
        >
          {relatedPractices ? (
            relatedPractices.map(item => <PracticeCard key={item.id} practice={item} />)
          ) : (
            <Preloader />
          )}
        </div>
      </div>
    ) : (
      ''
    );
  }
}
